export default __webpack_public_path__ + "static/media/a2.41621ed9.png";